import {config} from '../config'
import {loginErrorParam} from './constants'

export const privacyHref = `${config.API_SERVICE_URL}/privacy`
export const marketingHref = 'https://notability.com/'
export const galleryHref = 'https://notability.com/gallery'
export const loginError = `${config.LOGIN_SERVICE_URL}?${loginErrorParam}=true`
export const termsHref = `${config.API_SERVICE_URL}/terms`
